import { render, staticRenderFns } from "./ChartDataTable.vue?vue&type=template&id=539858c6&scoped=true"
import script from "./ChartDataTable.vue?vue&type=script&lang=js"
export * from "./ChartDataTable.vue?vue&type=script&lang=js"
import style0 from "./ChartDataTable.vue?vue&type=style&index=0&id=539858c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539858c6",
  null
  
)

export default component.exports